import { isPlainObject } from "@vue/shared";
import { bindActionCreators } from "redux";
import { getValueAtPath, withProperties } from "../../utils";
import { UPDATE_LOCALE } from "../helpers/actions";
import EventLog from "../../logger/events";

// export const getLocaleFromCurrency = (currency) => (["CFA", "XAF", "XOF"].includes(currency)) ? 'fr' : 'en';
export const getLocaleFromCurrency = (currency) => {
    // Portuguese-speaking countries
    if (["BRL", "AOA", "CVE", "GIP", "MZN", "STN"].includes(currency)) {
      return 'pt';
    }
    // French-speaking countries
    if (["CFA", "XAF", "XOF"].includes(currency)) {
      return 'fr';
    }
    return 'en';
  };

export default function state() {
    const NAME = "locale";
    const $state = Object.create(null);

    const { data, dispatch } = this;
    
    const currentCurrency = getValueAtPath(data, 'currency');

    const defaultLocale = getLocaleFromCurrency(currentCurrency);

    function Reducer(state = getValueAtPath(data, 'locale') || defaultLocale, action) {
        const payload = isPlainObject(action.payload) ? action.payload : {};

        switch(action.type) {
            case UPDATE_LOCALE: {
                const { locale } = payload;
                return locale || state;
            }

            default: return state;
        }
    }

    function updateLocale(locale) {
        return (dispatch) => {
            dispatch({ type: UPDATE_LOCALE, payload: {
                locale: locale || defaultLocale
            }});

            EventLog.changedLanguage(locale);
        }
    }

    withProperties($state, {
        NAME,
        Reducer,
        actions: withProperties(Object.create(null), { updateLocale }),
        exposedActions: withProperties(Object.create(null), {
            CurrentLocale: bindActionCreators({ switch: updateLocale }, dispatch)
        })
    });

    return (state = $state)
}